import api from "./api";

export const createBooking = (slug, payload) =>
  api.post(`/events/${slug}/book`, payload).then((res) => res.data);

export const getMyBookings = (page = 1) =>
  api.get("/my-bookings", { params: { page } }).then((res) => res.data);

export const getBooking = (reference) =>
  api.get(`/my-bookings/${reference}`).then((res) => res.data);

export const cancelBooking = (reference) =>
  api.post(`/my-bookings/${reference}/cancel`).then((res) => res.data);
